import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const AttendanceReport = Loadable(lazy(() => import('./AttendanceReport/AttendanceReport')));

const employeeReportRoutes = [
    { path: '/employee/reports/attendance-report', element: <AttendanceReport />, auth: authRoles.guest },
];

export default employeeReportRoutes;
